import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideAuth } from 'angular-auth-oidc-client';
import { routes } from './app.routes';
import { appConfig } from './config/config';

export const applicationConfig: ApplicationConfig = {
    providers: [provideRouter(routes), provideHttpClient(), provideAuth(appConfig.auth)],
};
